import { DateField, TextField } from '@mi-front/ui';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';

export function LtxMatchesReportForm(p: Record<string, unknown>) {
  const { $t } = useIntl();

  return (
    <div className="row">
      <div className="col-4">
        <DateField
          name="date"
          label={$t({
            id: 'audit.reportsScreen.ltxMatches.date',
            defaultMessage: 'Fecha',
          })}
          isOutsideRange={(date) => moment(date) > moment()}
        />
      </div>
      <div className="col-4">
        <TextField
          name="customId"
          label={$t({
            id: 'audit.reportsScreen.ltxMatches.customId',
            defaultMessage: 'Custom ID (opcional)',
          })}
        />
      </div>
    </div>
  );
}
